import { DataCard } from "@telefonica/mistica";
import { RenderTabs } from "./RenderTabs";
import { observer } from "mobx-react-lite";
import React from "react";

export interface TabContentProps {
	title?: string;
	tagText?: string;
	tabs?: string[] | null;
	contents: React.ReactNode[];
	withBorder?: boolean;
	analytics?: Array<() => Promise<void>>;
}

export const TabContent: React.FC<TabContentProps> = observer((props) => {
	const { contents, tabs, title, tagText, withBorder = true, analytics } = props;

	if (withBorder) {
		return <DataCard extra={<RenderTabs tabs={tabs} contents={contents} tagText={tagText} title={title} />} />;
	}

	return <RenderTabs tabs={tabs} contents={contents} tagText={tagText} title={title} analytics={analytics} />;
});
